import React from "react";
import { Button, Input, Radio, message } from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";

// Función para crear un filtro dropdown con radio buttons
export const getCustomFilterDropdown = (filters) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    const handleRadioClick = (filterValue) => {
      if (selectedKeys.includes(filterValue)) {
        // Si ya está seleccionado, limpiar (toggle off)
        setSelectedKeys([]);
        confirm({ closeDropdown: false });
      } else if (selectedKeys.length === 0) {
        // Solo permitir seleccionar si no hay nada seleccionado actualmente
        setSelectedKeys([filterValue]);
        confirm({ closeDropdown: false });
      } else {
        // Si hay algo seleccionado y es diferente, mostrar mensaje
        const currentSelection = filters.find(f => selectedKeys.includes(f.value))?.text;
        message.warning(`Primero deselecciona "${currentSelection}" antes de seleccionar otra opción`, 2);
      }
    };

    return (
      <div style={{ padding: 8, borderRadius: '6px', minWidth: '180px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {filters.map(filter => (
            <Radio
              key={filter.value}
              checked={selectedKeys.includes(filter.value)}
              onClick={() => handleRadioClick(filter.value)}
              style={{
                padding: '4px 6px',
                display: 'flex',
                alignItems: 'center',
                borderRadius: '4px',
                margin: '0',
                width: '100%',
                fontSize: '13px'
              }}
            >
              {filter.text}
            </Radio>
          ))}
        </div>
        <div style={{ marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #f0f0f0' }}>
          <Button 
            size="small" 
            onClick={() => { clearFilters(); confirm(); }} 
            style={{ 
              borderRadius: '4px',
              width: '100%'
            }}
            type="primary"
            className="gradient-button"
          >
            Limpiar
          </Button>
        </div>
      </div>
    );
  },
  filterIcon: (filtered) => (
    <FilterOutlined 
      style={{ color: filtered ? 'var(--color-naranja)' : undefined }} 
      title="" 
    />
  ),
});

// Función para obtener filtro de texto inmediato
export const getColumnSearchProps = (dataIndex, placeholder = "Buscar") => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div className="tabla-solicitudes-filtros-busqueda" style={{ padding: 6, borderRadius: '6px', width: '200px' }}>
      <Input
        placeholder={placeholder}
        value={selectedKeys[0]}
        onChange={(e) => {
          const value = e.target.value;
          setSelectedKeys(value ? [value] : []);
          // Filtro inmediato mientras escribes
          confirm({ closeDropdown: false });
        }}
        onPressEnter={() => confirm()}
        size="middle"
        style={{ 
          marginBottom: 6, 
          borderRadius: '4px',
          width: '100%'
        }}
        prefix={<SearchOutlined style={{ color: 'var(--color-naranja)' }} />}
        allowClear
      />
      <Button 
        type="primary"
        onClick={() => {
          clearFilters();
          confirm();
        }} 
        size="small"
        style={{ 
          borderRadius: '4px',
          width: '100%',
          fontSize: '12px',
          height: '24px'
        }}
        className="gradient-button"
      >
        Limpiar
      </Button>
    </div>
  ),
  filterIcon: (filtered) => (
    <SearchOutlined 
      style={{ color: filtered ? 'var(--color-naranja)' : undefined }} 
      title="" 
    />
  ),
  onFilter: (value, record) => {
    const fieldValue = record[dataIndex];
    if (fieldValue === null || fieldValue === undefined) return false;
    return fieldValue.toString().toLowerCase().includes(value.toLowerCase());
  },
});